'use client';

import { useHasAuctionEnded } from '@/hooks/useHasAuctionEnded';
import { useSession } from '@/hooks/useSession';

export interface ContactDetailsWrapperProps {
  isEnded: boolean;
  isOwnPayment: boolean;
}

export function EntryContactDetailsWrapper({
  isOwnPayment,
  isEnded,
  children,
}: React.PropsWithChildren<ContactDetailsWrapperProps>) {
  const { currentUser } = useSession();
  const isAdmin = currentUser.data?.user?.isAdmin ?? false;
  const hasAuctionEnded = useHasAuctionEnded(isEnded);

  if (!isOwnPayment && hasAuctionEnded && !isAdmin) return null;

  return children;
}
